import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { AnswersBox } from "./AnswersBox";
import { AnswerSubmission } from "./AnswerSubmission";

export const SubmissionSection = ({
  assignmentQuestion,
  identifiers,
  answers,
  showSubmissionHubLink = false,
  submissionHubUrl = null,
}) => {
  return (
    <Grid container spacing={4} direction={"row"} sx={{ mt: 2, mb: 2 }}>
      <Grid size={{ xs: 12, md: 4 }}>
        <AnswerSubmission
          assignmentQuestion={assignmentQuestion}
          identifiers={identifiers}
          answers={answers}
          showSubmissionHubLink={showSubmissionHubLink}
          submissionHubUrl={submissionHubUrl}
        />
      </Grid>
      <Grid
        size={{ xs: 12, md: 8 }}
        sx={{ position: { xs: "static", md: "relative" }, minHeight: 0 }}
      >
        <Box
          sx={{
            position: { xs: "static", md: "absolute" },
            inset: { md: 0 },
          }}
        >
          <AnswersBox
            answers={answers}
            assignmentId={assignmentQuestion.assignment.id}
            assignmentQuestionId={assignmentQuestion.id}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
